import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Text from 'components/common/Text/Text'
import Link from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import ProductPrice from '../ProductPrice'
import { MAP } from './constants'

const Product = ({
  title,
  imagePath,
  brandLogoUrl,
  details,
  productDisplayName,
  tireDetailUrl,
  handleProductClick,
  tireBadges = []
}) =>
  <ProductWrapper>
    <Category headline centered size={ 24 }>{ title }</Category>
    <Media.Desktop>
      <Img src={ `${imagePath}?$BOT-BestMatches-Tire-Desktop-w180$` } />
    </Media.Desktop>
    <Media.Mobile>
      <Img src={ `${imagePath}?$BOT-BestMatches-Tire-Mobile-w120$` } />
    </Media.Mobile>
    <Description>
      <BrandLogo url={ `${brandLogoUrl}?$BOT-BestMatches-Brand-Desktop-h35$` } alt="brand-logo" />
      <ProductPrice details={ details } />
      <ProductLink block to={ tireDetailUrl } onClick={ handleProductClick }>{ productDisplayName }</ProductLink>
      {
        tireBadges && tireBadges.map((item, index) =>
          <Icon asset={ MAP[item.name] } margin="0 5px 0 0" />
        )
      }
    </Description>
  </ProductWrapper>

Product.propTypes = {
  brandLogoUrl: PropTypes.string,
  details: PropTypes.shape(),
  handleProductClick: PropTypes.func,
  imagePath: PropTypes.string,
  productDisplayName: PropTypes.string,
  tireBadges: PropTypes.arrayOf(PropTypes.object),
  tireDetailUrl: PropTypes.string,
  title: PropTypes.string
}

export default Product


const ProductWrapper = styled.div`
  border: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('padding', '22px 16px 16px', '20px 10px')}
  ${Media.desktop`
    height: 420px;
  `}
`

const Category = styled(Text)`
  ${Mixin.responsive('margin-bottom', '15px', '20px')}
`

const Description = styled.div`
  ${Media.mobile`
    display: inline-block;
    vertical-align: top;
  `}
`

const Img = styled.img`
  ${Mixin.responsive('margin', '12px 0', '0 10px 0 0')}
  ${Mixin.responsive('width', '180px', '120px')}
  ${Mixin.responsive('height', '180px', '120px')}
`

const BrandLogo = styled.div`
  position: relative;
  height: 35px;
  width: 120px;
  display: block;
  ${Mixin.responsive('margin-bottom', '12px', '10px')};

  ::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(${props => props.url}) 50% 50% no-repeat;
    background-size: contain;
    content: '';
  }
`

const ProductLink = styled(Link)`
  ${Mixin.responsive('margin', '12px 0', '10px 0')}
`
